import * as THREE from "three";
import { createLabel } from "../../../TOOLS/LabelFactory"

export class City {
  constructor(store, parent, label, id, district, possible = false) {
    this.store = store;
    this.parent = parent;
    this.label = label;
    this.id = id;
    this.district = district;
    this.possible = possible;
    this.group = new THREE.Group();
    this.parent.add(this.group);
    this.colleagueGroup = new THREE.Group();
    this.colleagueGroup.position.y = 1;
    this.group.add(this.colleagueGroup);
    this.meshGroup = new THREE.Group();
    this.group.add(this.meshGroup);
    this.model = null;
    this.nameLabel = null;
    this.colleagues = [];
    this.baseScale = 0.9;
    this.targetScale = this.baseScale;
    this.hoverTimer = null;
    this.originalLabel = label;
    this.load();
  }

async load() {
    this.model = this.store.assetManager.getModel("location");
    this.model.scale.setScalar(0.9);
    this.model.position.set(0, 0.7, 0);
    this.model.traverse((child) => {
      if (child.isMesh) {
        child.castShadow = true;
        child.receiveShadow = true;

        if (this.possible) {

            child.material = child.material.clone();

            child.material.color.set(0x888888);
            child.material.transparent = true;
            child.material.opacity = 0.2;
        }
      }
    });
    this.model.scale.setScalar(this.baseScale);
    this.model.userData.type = 'CITY';
    this.model.userData.instance = this;
    this.store.input.clickables.push(this.model);
    
    const box = new THREE.Box3().setFromObject(this.model);
    const size = new THREE.Vector3();
    box.getSize(size);
    this.nameLabel = createLabel(this.label, {fontSize: this.store.config.isSmall ? 72 : 72, position: new THREE.Vector3(0, size.y - .5, 0)});
    this.nameLabel.scale.setScalar(0.35);
    // A felirat ne legyen kattintható
    this.nameLabel.raycast = () => {};
    this.model.add(this.nameLabel);
    this.meshGroup.add(this.model);
    
  }

  update() {
    if (!this.model) return;
    const current = this.model.scale.x;
    const next = THREE.MathUtils.lerp(current, this.targetScale, 0.15);
    this.model.scale.setScalar(next);
  }

  getWorldPosition() { return this.group.getWorldPosition(new THREE.Vector3());}

  setHover(hovered) {this.targetScale = hovered ? this.baseScale * 1.4 : this.baseScale;}

  dispose() {this.parent.remove(this.group);}
}